import request from '@/utils/request'


//往来单位

//查询仓库列表
export function getWldwList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/wldw/list",
        data: data
    })
}


//新增往来单位
export function addOrUpdSave(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/wldw/addOrUpdSave",
        data: data
    })
}

//根据ID查询往来单位详细信息
export function detail(data) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/wldw/detail/" + data
    })
}

//根据ID删除往来单位
export function remove(data) {
    return request({
        method: 'delete',
        url: "/yzdservice/enterprise/wldw/remove/" + data
    })
}

//根据单位名称查询入网单位信息
export function selYzddwByDwmc(data) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/wldw/selYzddwByDwmc?dwmc=" + data
    })
}

//导出
export function excelwriter(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/wldw/excelwriter",
        data: data,
        responseType: 'blob',
    })
}
